module.exports = __webpack_public_path__ + "static/media/doc-inti-2.5a164d4d.png";